/*
 * newsbot - forked from autobrr
 */

interface NavItem {
  name: string;
  path: string;
  exact?: boolean;
}

export interface RightNavProps {
  // No auth for now
}

export const NAV_ROUTES: Array<NavItem> = [
  { name: "Dashboard", path: "/", exact: true },
  { name: "Stories", path: "/stories" },
  { name: "Trends", path: "/trends" },
  { name: "Filters", path: "/filters" },
  { name: "Suggestions", path: "/suggestions" },
  { name: "Logs", path: "/logs" },
];
